import { EMode } from "../../../../shared/components/features/event-scheduler/enums/event.enums";

export const eventSchedulerValidator = (eventScheduler: any) => {
  if (!eventScheduler || typeof eventScheduler !== "object") return false;

  const { eventPreferences = {} } = eventScheduler;

  const {
    bufferedTimes,
    fixedTimes,
    eventConfig,
  } = eventPreferences;

  if (!eventConfig) return false;

  const { emitter, status, mode, startDate, endDate, frequency } = eventConfig;

  if(mode === EMode.CONFIGURE_LATER) return true

  const baseValid =
    !!emitter?.type &&
    !!emitter?.url &&
    !!status &&
    !!mode;

  if (!baseValid) return false;

  const hasFixedTimes = fixedTimes !== undefined;
  const hasBufferTimes = bufferedTimes !== undefined;

  if (!hasFixedTimes && !hasBufferTimes) return false;

  if (mode === "SINGLE_EXECUTION") {
    return !!startDate;
  }

  if (mode === "REPETITIVE") {
    if (!startDate || !endDate || !frequency?.type) return false;

    const { type, interval } = frequency;
    const hasInterval = Array.isArray(interval) && interval.length > 0;

    const validDateValue = (val: string) => {
      const [mm, dd] = val.split("-").map(Number);
      return (
        /^\d{2}-\d{2}$/.test(val) &&
        mm >= 1 &&
        mm <= 12 &&
        dd >= 1 &&
        dd <= 31
      );
    };

    const conditions: Record<string, boolean> = {
      weekly: hasInterval,
      monthly: hasInterval,
      yearly:
        hasInterval &&
        interval.every(
          (item) =>
            item?.type === "date" &&
            validDateValue(item?.value)
        ),
    };

    return conditions[type] ?? false;
  }

  return false;
};
